import { downloadFile } from 'utils/file'

const S3_HOSTNAME = /(s3\..+\.amazonaws\.com)|minio/i

export const downloadS3File = async (configurationUrl: string): Promise<void> => {
  const fileName: string | undefined = getFileName(configurationUrl)

  if (!ensureUrlLeadsToS3(configurationUrl) || !fileName) {
    throw new Error(`Invalid S3 URL or file name: ${configurationUrl}`)
  }

  try {
    const response: Response = await fetch(configurationUrl)

    if (!response.ok) {
      throw new Error(`S3 responded with ${response.status} ${response.statusText}`)
    }

    const blob: Blob = await response.blob()

    downloadFile(blob, fileName)
  } catch (error) {
    throw new Error(
      `Failed to download file from S3: ${(error as Error).message || configurationUrl}`,
    )
  }
}

const getFileName = (configurationUrl: string): string | undefined =>
  new URL(configurationUrl).pathname.split('/').filter(Boolean).pop()

const ensureUrlLeadsToS3 = (configurationUrl: string): boolean =>
  S3_HOSTNAME.test(new URL(configurationUrl).hostname)
